export const VE_OPEN_POPUP = 've-open-popup'
export const VE_PAGE_CHANGE = 've-page-change'
